import { Injectable } from "@angular/core";
import { IndexDbService } from "./index-db.service";
import { Subject } from "rxjs";
import { DBRecordList } from "@app/models/record.model";
import { INDEXDBTABLE } from "@app/shared/enum/indexdb.enum";

@Injectable({
    providedIn: 'root'
})
export class NotelistDbService extends IndexDbService {
    private _addNote: Subject<DBRecordList> = new Subject();

    get db() {
        return this._db?.transaction(this.tableName, 'readwrite');
    }

    get tableName() {
        return INDEXDBTABLE.TABLENOTELIST;
    }


    public async addNotesByGroup(notes: DBRecordList) {
        return new Promise(async (resolve, _) => {
            if (!this.db) {
                console.log('can not find indexDb request');
                resolve(false);
                return;
            }
            const checkExist = await this.getGroupNotes(notes.groupId);
            const transaction = this.db.objectStore(this.tableName);
            if (checkExist) {
                const update = transaction.put(notes);
                update.onsuccess = () => {
                    resolve(true);
                };
                update.onerror = (result) => {
                    console.log(result);
                    resolve(false);
                };
                return;
            }
            const request = transaction.add(notes);
            request.onsuccess = async () => {
                console.log(`notes successed`);
                this._addNote.next(notes);
                resolve(true);
            }

            request.onerror = async (err) => {
                console.error(`Error to add new notes to group: ${err}`);
                resolve(true);
            }

        })

    }

    public async getGroupNotes(groupId: string):Promise<DBRecordList | null> {
        return new Promise(async (resolve, _) => {
            if (!this.db) {
                console.log('can not find indexDb request');
                resolve(null);
                return;
            }
            const table = this.db.objectStore(this.tableName);
            if (!table) {
                resolve(null);
                return;
            }
            const excuteindex = table.get(groupId);
            excuteindex.onsuccess = () => {
                resolve(excuteindex.result);

            }
            excuteindex.onerror = (event) => {
                console.log(event);
                resolve(null);
            }
        })

    }



}